// After Sales Page Initialization Handlers
// This file handles initialization of page-specific JavaScript in a Turbolinks-compatible way

// Create a namespace for our functions
window.AfterSalesHandlers = window.AfterSalesHandlers || {};

// Function to initialize datatables
AfterSalesHandlers.initializeDataTables = function() {
  if (typeof $.fn.DataTable !== 'undefined') {
    $('.datatable').each(function() {
      // Check if DataTable is already initialized on this element
      if (!$.fn.DataTable.isDataTable(this)) {
        $(this).DataTable({
          responsive: true,
          language: {
            search: "",
            searchPlaceholder: "Search...",
            paginate: {
              next: "→",
              previous: "←"
            }
          },
          dom: "<'flex items-center justify-between'<'flex-1'f><'flex-shrink-0'l>>" +
               "<'overflow-x-auto't>" +
               "<'flex items-center justify-between'<'flex-1'i><'flex-shrink-0'p>>",
          // Common datatable options
          pageLength: 10,
          lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
        });
      }
    });
  }
};

// Function to initialize select2 dropdowns
AfterSalesHandlers.initializeSelect2 = function() {
  if (typeof $.fn.select2 !== 'undefined') {
    $('.select2').each(function() {
      // Avoid re-initializing
      if (!$(this).hasClass('select2-hidden-accessible')) {
        $(this).select2({
          width: '100%',
          placeholder: $(this).data('placeholder') || 'Select an option'
        });
      }
    });
  }
};

// Function to handle flash messages
AfterSalesHandlers.initializeFlashMessages = function() {
  // Find dismissable flash messages
  const flashMessages = document.querySelectorAll('.flash-message .dismiss-flash');
  
  if (flashMessages.length > 0) {
    flashMessages.forEach(button => {
      // Only add the event listener if it doesn't already have one
      if (!button.hasAttribute('data-flash-initialized')) {
        button.setAttribute('data-flash-initialized', 'true');
        button.addEventListener('click', function() {
          const flashElement = this.closest('.flash-message');
          if (flashElement) {
            flashElement.classList.add('opacity-0');
            setTimeout(() => {
              flashElement.remove();
            }, 300);
          }
        });
      }
    });
    
    // Auto-dismiss success/info messages after 5 seconds
    document.querySelectorAll('.flash-message.success, .flash-message.info').forEach(flash => {
      setTimeout(() => {
        flash.classList.add('opacity-0');
        setTimeout(() => {
          flash.remove();
        }, 300);
      }, 5000);
    });
  }
};

// Function to initialize any modals on the page
AfterSalesHandlers.initializeModals = function() {
  // Modal open buttons
  const modalOpenButtons = document.querySelectorAll('[data-modal-target]');
  
  if (modalOpenButtons.length > 0) {
    modalOpenButtons.forEach(button => {
      if (!button.hasAttribute('data-modal-initialized')) {
        button.setAttribute('data-modal-initialized', 'true');
        button.addEventListener('click', function() {
          const targetId = this.getAttribute('data-modal-target');
          const modal = document.getElementById(targetId);
          
          if (modal) {
            modal.classList.remove('hidden');
            // Prevent scrolling on the body
            document.body.style.overflow = 'hidden';
          }
        });
      }
    });
  }
  
  // Modal close buttons
  const modalCloseButtons = document.querySelectorAll('[data-modal-close]');
  
  if (modalCloseButtons.length > 0) {
    modalCloseButtons.forEach(button => {
      if (!button.hasAttribute('data-modal-initialized')) {
        button.setAttribute('data-modal-initialized', 'true');
        button.addEventListener('click', function() {
          const modal = this.closest('.modal');
          
          if (modal) {
            modal.classList.add('hidden');
            // Restore scrolling
            document.body.style.overflow = '';
          }
        });
      }
    });
  }
  
  // Close modal when clicking on backdrop
  const modalBackdrops = document.querySelectorAll('.modal-backdrop');
  
  if (modalBackdrops.length > 0) {
    modalBackdrops.forEach(backdrop => {
      if (!backdrop.hasAttribute('data-modal-initialized')) {
        backdrop.setAttribute('data-modal-initialized', 'true');
        backdrop.addEventListener('click', function(e) {
          // Only close if the actual backdrop was clicked, not its children
          if (e.target === this) {
            const modal = this.closest('.modal');
            
            if (modal) {
              modal.classList.add('hidden');
              // Restore scrolling
              document.body.style.overflow = '';
            }
          }
        });
      }
    });
  }
};

// Handle mobile navigation issues with sidebar
AfterSalesHandlers.ensureMobileNavigation = function() {
  // Get relevant elements
  const sidebar = document.querySelector('.sidebar-container');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuButton = document.getElementById('mobile-menu-button');
  
  // Skip if elements don't exist
  if (!sidebar || !mobileMenu) return;
  
  // On mobile, ensure sidebar is hidden
  if (window.innerWidth < 768) {
    console.log("Mobile view - ensuring sidebar is hidden");
    sidebar.classList.add('hidden');
    sidebar.style.display = 'none';
    mobileMenu.style.display = 'none';
    
    // Reset any main content margins
    const mainContent = document.querySelector('.main-content');
    if (mainContent) {
      mainContent.style.marginLeft = '0';
    }
  } else {
    // On desktop, ensure sidebar is visible and mobile menu is hidden
    console.log("Desktop view - ensuring proper sidebar display");
    sidebar.classList.remove('hidden');
    sidebar.style.display = 'block';
    mobileMenu.style.display = 'none';
    
    // Add margin to main content
    const mainContent = document.querySelector('.main-content');
    if (mainContent) {
      mainContent.style.marginLeft = '16rem';
    }
  }
  
  // Handle window resize events to maintain proper state
  window.addEventListener('resize', function() {
    if (window.innerWidth < 768) {
      // Mobile view
      sidebar.classList.add('hidden');
      sidebar.style.display = 'none';
      mobileMenu.style.display = 'none';
      
      const mainContent = document.querySelector('.main-content');
      if (mainContent) {
        mainContent.style.marginLeft = '0';
      }
    } else {
      // Desktop view
      sidebar.classList.remove('hidden');
      sidebar.style.display = 'block';
      mobileMenu.style.display = 'none';
      
      const mainContent = document.querySelector('.main-content');
      if (mainContent) {
        mainContent.style.marginLeft = '16rem';
      }
    }
  });
};

// Main initialization function for all page-specific handlers
function initializeAllPageHandlers() {
  console.log('Initializing After Sales page handlers with Turbolinks support');
  
  // Initialize common UI components
  AfterSalesHandlers.initializeDataTables();
  AfterSalesHandlers.initializeSelect2();
  AfterSalesHandlers.initializeFlashMessages();
  AfterSalesHandlers.initializeModals();
  
  // Fix for mobile menu and sidebar issues
  AfterSalesHandlers.ensureMobileNavigation();
  
  // Any other common initialization logic here
}

// Run on both regular page load and Turbolinks navigation
document.addEventListener('DOMContentLoaded', initializeAllPageHandlers);
document.addEventListener('turbolinks:load', initializeAllPageHandlers);

// Clean up before caching
document.addEventListener('turbolinks:before-cache', function() {
  // Destroy DataTables before caching to prevent duplicate initialization issues
  if (typeof $.fn.DataTable !== 'undefined') {
    $('.datatable').each(function() {
      if ($.fn.DataTable.isDataTable(this)) {
        $(this).DataTable().destroy();
      }
    });
  }
  
  // Clean up select2 instances
  if (typeof $.fn.select2 !== 'undefined') {
    $('.select2-hidden-accessible').select2('destroy');
  }
  
  // Ensure mobile menu is hidden before caching
  const mobileMenu = document.getElementById('mobile-menu');
  if (mobileMenu) {
    mobileMenu.style.display = 'none';
  }
});

// Export our namespace so it can be accessed from inline scripts if needed
export default AfterSalesHandlers;
export const ensureMobileNavigation = AfterSalesHandlers.ensureMobileNavigation; 